import { styled } from 'stitches.config'

export const BetterThanCookedRoot = styled('div', {
  maxWidth: '$max',
  px: '$2',
})

export const TitleWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  '@bp2': {
    flex: 1,
    paddingLeft: '$6',
    paddingRight: '$6',
  },

  '@bp3': {
    paddingLeft: '$11',
    paddingRight: '$11',
  },
})

export const Description = styled('div', {
  '@bp2': {
    flex: 2,
    paddingLeft: '$6',
    paddingRight: '$6',
  },

  '@bp3': {
    paddingLeft: '$11',
    paddingRight: '$11',
  },
})
